<template>
  <div class="skeleton-container">
    <div class="skeleton-wrapper header">
      <div class="header">
        <div class="description">
          <div class="skeleton-loader title" />
          <div class="skeleton-loader sub-title" />
        </div>
        <div class="buttons">
          <div class="skeleton-loader skeleton-button" />
        </div>
      </div>
    </div>
    <div class="skeleton-wrapper body">
      <div class="row">
        <div class="column">
          <div class="skeleton-loader full" />
          <div class="skeleton-loader title" />
          <div class="skeleton-loader full" />
          <div class="skeleton-loader title" />
        </div>
      </div>
      <div class="row">
        <div class="column">
          <div class="skeleton-loader full" />
          <div class="skeleton-loader title" />
          <div class="skeleton-loader full" />
          <div class="skeleton-loader title" />
        </div>

        <div class="column"></div>
      </div>
      <div class="row">
        <div class="column">
          <div class="skeleton-loader full" />
          <div class="skeleton-loader title" />
          <div class="skeleton-loader full" />
          <div class="skeleton-loader title" />
        </div>
      </div>
      <div class="row">
        <div class="column">
          <div class="skeleton-loader full" />
          <div class="skeleton-loader title" />
          <div class="skeleton-loader full" />
          <div class="skeleton-loader title" />
        </div>
        <div class="column"></div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="less">
.skeleton-container {
  padding: 48px 24px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  .skeleton-wrapper {
    flex-grow: 1;
    overflow: hidden;
    line-height: 1em;
    margin-bottom: 0 !important;
    .skeleton-loader {
      height: 16px;
      width: 100%;
      border-radius: 8px;
      display: block;
      margin-bottom: 10px;
    }
    .description {
      width: 100%;
    }
    .title {
      width: 70%;
      height: 28px;
    }
    .sub-title {
      width: 50%;
      height: 24px;
    }
    .full {
      width: 100%;
      height: 22px;
    }
    .header {
      display: grid;
      grid-template-columns: auto 200px;
      column-gap: 16px;
    }
    .skeleton-button {
      height: 40px;
      width: 200px;
    }
    &.body {
      margin-top: 48px;
      display: flex;
      flex-direction: column;
      gap: 24px;
      width: 100%;
      .row {
        flex-grow: 1;
        display: flex;
        gap: 24px;
        // flex-direction: column;
      }
      .column {
        flex-grow: 1;
      }
    }
  }
}
</style>
